import React, { useEffect } from "react";
import Input from "componentsTemplate/Input/Input";
import Label from "componentsTemplate/Label/Label";
import { get } from "lodash";

const FormFieldInput = ({
  label,
  fieldName,
  type = "text",
  extraProps = {},
  classe = "block",
  formData,
  handleChange,
  error = null,
}: any) => {
  let value = get(formData, fieldName);

  // If the type is date, format the value to YYYY-MM-DD
  if (type === "date" && value) {
    value = value.split(" ")[0];
  }

  return (
    <label className={classe} key={fieldName}>
      <Label>{label}</Label>
      <Input
        type={type}
        className="mt-1"
        value={value}
        onChange={(e) => handleChange(fieldName, e.target.value)}
        {...extraProps}
      />
      {error && <span className="text-red-500 text-sm">{error}</span>}
    </label>
  );
};

export default FormFieldInput;